/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2025 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
import * as e from "react";
import { provideIntlService as r, registerForIntl as a } from "@progress/kendo-react-intl";
class m extends e.Component {
  render() {
    const t = this.props.item;
    return /* @__PURE__ */ e.createElement("div", { className: "k-timestamp" }, r(this).formatDate(t.timestamp, "D"));
  }
}
a(m);
export {
  m as default
};
